import React, { useEffect, useState } from "react";
import "./ProductWeightModal.css";

import Backdrop from "@mui/material/Backdrop";
import Modal from "@mui/material/Modal";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import InputLabel from "@mui/material/InputLabel";
import { updateProductsDetails } from "../../../../services/product.service";
import CircularLoader from "../../../../Components/CircularLoader/CircularLoader";
import { useTranslation } from "react-i18next";

export default function ProductWeightModal({
  open,
  setOpen,
  setSnack,
  setProducts,
}) {
  const { t } = useTranslation(["inventory", "common"]);
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);
  const [changed, setchanged] = useState(false);

  const handleFieldChange = (e) => {
    const { name, value } = e.target;
    setData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleClose = () => {
    setLoading(false);
    setchanged(false);
    setData({});
    setOpen(false);
  };

  const handleSave = async () => {
    try {
      setLoading(true);
      const productUpdateArray = {
        weight_unit: data?.weight_unit,
        weight: data?.weight,
      };

      const response = await updateProductsDetails(
        productUpdateArray,
        data?.id
      );
      if (!response.error) {
        setProducts((prevProducts) => {
          return {
            ...prevProducts,
            data: prevProducts?.data?.map((product, index) => {
              if (product.id === data?.id) {
                return {
                  ...product,
                  weight_unit: response?.data?.result?.weight_unit,
                  weight: response?.data?.result?.weight,
                };
              } else if (open?.parent_id == product.id) {
                let result = product.children.map((children, idx) => {
                  if (children.id === data?.id) {
                    return {
                      ...children,
                      weight_unit: response?.data?.result?.weight_unit,
                      weight: response?.data?.result?.weight,
                    };
                  } else {
                    return {
                      ...children,
                    };
                  }
                });
                return {
                  ...product,
                  children: result,
                };
              }
              return product;
            }),
          };
        });
        setOpen(data);
        setSnack((snack) => {
          return {
            ...snack,
            open: true,
            text: t("productModals.productUpdatedSuccessfully"),
            severity: "success",
          };
        });
        setLoading(false);
      } else {
        setSnack((snack) => {
          return {
            ...snack,
            open: true,
            text: t("common:messages.somethingWentWrong"),
            severity: "error",
          };
        });
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      console.log("try catch", error);
      setSnack((snack) => {
        return {
          ...snack,
          open: true,
          text: t("common:messages.somethingWentWrong"),
          severity: "error",
        };
      });
    }
  };

  useEffect(() => {
    setData(open);
  }, [open]);

  useEffect(() => {
    let hasChanges = false;

    if (
      open?.weight_unit != data?.weight_unit ||
      open?.weight != data?.weight
    ) {
      hasChanges = true;
    }
    if (open && data) {
      setchanged(hasChanges);
    }
  }, [open, data]);

  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <div className="prod__weight_modal ">
          <div className="prod__weight_modalheading">{t("productModals.editProductWeight")}</div>
          <div className="prod__weightmdl_formbox " id="products_dimensions">
            <div className="prod__weightmdl_formrow">
              <div className="prod__weightmdl_formcol" style={{ width: "50%" }}>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label" size="small">
                    {t("productModals.weightUnit")}
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    size="small"
                    onChange={(e) => handleFieldChange(e)}
                    value={data?.weight_unit?.toLowerCase() || ""}
                    id="weight_unit"
                    label={t("productModals.weightUnit")}
                    name="weight_unit"
                  >
                    <MenuItem value="lb">{t("units.lb")}</MenuItem>
                    <MenuItem value="kg">{t("units.kg")}</MenuItem>
                  </Select>
                </FormControl>
              </div>
              <div className="prod__weightmdl_formcol" style={{ width: "50%" }}>
                <TextField
                  fullWidth
                  size="small"
                  type="number"
                  onChange={(e) => handleFieldChange(e)}
                  label={t("productModals.weight")}
                  name="weight"
                  value={data?.weight || ""}
                  variant="outlined"
                  className="prod__weightmdl_formfield"
                />
              </div>
            </div>
          </div>
          <div className="prod__weight_modalfooter">
            <div className="prod__weight_modalcncl" onClick={handleClose}>
              {t("common:actions.close")}
            </div>
            {changed === true ? (
              <div className="prod__weight_modalsave" onClick={handleSave}>
                {loading ? <CircularLoader /> : t("common:actions.save")}
              </div>
            ) : null}
          </div>
        </div>
      </Modal>
    </div>
  );
}
